module.exports = __webpack_public_path__ + "static/python-1fc8f29c2e64e9b578efbaa2b6eb5e88.png";